import React from "react";

export default function ResultTableManual({
  currentQty,
  qty,
  onChangeQty,
  onChangeOperator,
  operator,
}) {
  const table = {
    header: [
      {
        id: 1,
        title: "재고수량",
      },
      {
        id: 2,
        title: "선택된 재고의 조정 수량",
      },
    ],
  };

  return (
    <>
      <div className="w-full block whitespace-nowrap overflow-auto">
        <table className="w-full text-center text-black">
          <thead>
            <tr className="border border-[#dddddd]" key={0}>
              {table.header.map((val) => (
                <th
                  className="p-2 bg-[#f2f2f4] border border-[#dddddd] font-normal"
                  key={val.id}
                >
                  {val.title}
                </th>
              ))}
            </tr>
          </thead>

          <tbody>
            <tr>
              <td className="px-3 py-1 border border-[#dddddd]">
                {currentQty}
              </td>
              <td className="px-3 py-1 border border-[#dddddd]">
                <div className="flex gap-2">
                  <div className="flex items-center">
                    <input
                      type="radio"
                      className="flex-none accent-primary-black mr-2"
                      id="plusAdjustment"
                      defaultChecked={true}
                      value="+"
                      name="adjustment"
                      onChange={() => onChangeOperator("+")}
                    />
                    <label htmlFor="plusAdjustment" className="mr-2">
                      (+) 조정
                    </label>
                  </div>
                  <div className="flex items-center">
                    <input
                      disabled={currentQty <= 0}
                      type="radio"
                      className="flex-none accent-primary-black mr-2"
                      id="minAdjustment"
                      value="+"
                      name="adjustment"
                      onChange={() => onChangeOperator("-")}
                    />
                    <label htmlFor="minAdjustment" className="mr-2">
                      (-) 조정
                    </label>
                  </div>
                  <input
                    type="number"
                    onChange={onChangeQty}
                    value={qty}
                    className={`w-[5rem] border rounded-[4px] p-[6px] ${
                      operator === "-" && qty > currentQty
                        ? "border-[#FF0000] outline-[#FF0000]"
                        : "border-button-grey outline-none"
                    }`}
                  />
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </>
  );
}
